import React from 'react';
import '../../styles/components/StateMessage.css';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
export default ({ text }) => (
  <div className='alert alert-success info-box' role='alert'>
    {text}
  </div>
);
